import { useClientContext } from "../../../hooks/ClientContext"
import { useGetFactFindSummaryQuery } from "../../../services/clientfactfind";

export const useGetFactFindSummaryDetails = () => {
    const { id: masterAccountId } = useClientContext();
    const { data, error, isLoading } = useGetFactFindSummaryQuery({masterAccountId});

    return {
        data, error, isLoading
    }
}